import React from 'react';
import clsx from 'clsx';

import { BaseComponentProps } from '@utils/types/baseComponents';
import WysiwygText from '@components/_shared/wysiwygText';

import styles from './styles.module.scss';

type Props = {
  question: string;
  answerRaw: any;
  index: number;
  selectedFAQ: number | null;
  onClick: (index: number) => void;
  highlightSelected?: boolean;
  noBorder?: boolean;
} & BaseComponentProps;

const FAQ = (props: Props) => {
  const {
    index,
    selectedFAQ,
    onClick,
    question,
    answerRaw,
    highlightSelected = false,
    noBorder = false,
    containerStyle,
    theme = 'light',
  } = props;

  return (
    <div
      className={clsx([
        styles.faq,
        noBorder && styles.noBorder,
        highlightSelected && styles.highlighted,
        selectedFAQ === index && styles.open,
        styles[theme],
        containerStyle,
      ])}
      onClick={() => onClick(index)}
    >
      <h3 className={clsx([styles.faq__question, styles[theme]])}>
        {question}
      </h3>
      <h4 className={styles.faq__answer}>
        {typeof answerRaw === 'string' ? (
          answerRaw
        ) : (
          <WysiwygText content={answerRaw} />
        )}
      </h4>
    </div>
  );
};

export default FAQ;
